import { FC } from 'react';
import styled from 'styled-components';
import trophyImage from './achievements/grey_trophy.png';

const Container = styled.div`
  overflow: hidden;
  position: relative;
  padding: 5px;
  background: rgb(159, 210, 247);
  background: linear-gradient(0deg, rgba(159, 210, 247, 1) 0%, rgba(95, 186, 242, 1) 100%);
  grid-area: achievements;
`;

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[1000]};
    font-size: 1.125rem;
    margin-left: 0.9375rem;
    font-weight: ${type.weight.regular};
  `;
});

const ComingSoonBanner = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    width: 100%;
    text-align: center;
    color: ${color.grayscale[1000]};
    margin-top: 30px;
    font-size: ${type.size.large};
    background: rgba(50, 200, 50, 1);
    transform: rotate(-30deg);
    position: absolute;
    width: 250px;
    bottom: 28px;
    right: -40px;
  `;
});

const ImageWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
`;

const AchievementsWidget: FC = () => {
  return (
    <Container>
      <Title>Achievements</Title>

      <ImageWrapper>
        <Image alt="achievements_image" src={trophyImage} />
      </ImageWrapper>

      <ComingSoonBanner>Coming Soon</ComingSoonBanner>
    </Container>
  );
};

export default AchievementsWidget;
